import { render, staticRenderFns } from "./DetailsContent.vue?vue&type=template&id=efda2376&scoped=true&"
import script from "./DetailsContent.vue?vue&type=script&lang=js&"
export * from "./DetailsContent.vue?vue&type=script&lang=js&"
import style0 from "./DetailsContent.vue?vue&type=style&index=0&id=efda2376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efda2376",
  null
  
)

export default component.exports